<template>
    <div class="sustainable-component admin-company-workspace" style="position:relative;">

        <!--<div class="bg-success mb-3 p-3 rounded">vue admin-company-workspace</div>-->
        <div class="container-fluid p-0 mt-3">

            <div class="row px-3">
                <div class="col-12 p-0">
                    <CommonLabelContainer title="Skapa företag" class="mt-5 mb-3">
                        <v-form v-model="valid" ref="form">
                            <div class="container-fluid p-0">
                                <div class="row">
                                    <div v-if="availableExampleCompanies.length > 0" class="col-12 col-md-6">
                                        <div class="container-fluid p-0">
                                            <div class="row">
                                                <div class="col">
                                                    Fyll i namn nedan för att skapa företag.
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col">
                                                    <v-text-field bg-color="white"
                                                                  :rules="[rules.required]"
                                                                  name="CompanyName"
                                                                  id="CompanyName"
                                                                  type="text"
                                                                  label="Företagsnamn"
                                                                  variant="outlined"
                                                                  v-model="company.Name"
                                                                  focused="true"></v-text-field>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <v-btn variant="tonal" class="bg-primary" @click="createCompany">
                                                        Skapa
                                                    </v-btn>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="col-12 col-md-6">
                                        <div class="container-fluid">
                                            <div class="row">
                                                <div class="col">
                                                    Välj ett exempelbolag för att skapa ett nytt företag från en mall.
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col">
                                                    <v-text-field bg-color="white"
                                                                  :rules="[rules.required]"
                                                                  name="CopyName"
                                                                  id="CopyName"
                                                                  type="text"
                                                                  label="Företagsnamn"
                                                                  variant="outlined"
                                                                  v-model="exampleCompany.Name"
                                                                  focused="true"></v-text-field>
                                                </div>
                                            </div>
                                            <!--<div class="row">
                                            <div class="col">
                                                <v-btn variant="tonal" class="bg-primary" @click="createExample">
                                                    Skapa
                                                </v-btn>
                                            </div>
                                        </div>-->
                                            <div class="row">
                                                <div class="col">
                                                    <ExampleCompanyMenu :items="availableExampleCompanies"
                                                                        button-text="Skapa"
                                                                        @select="createExampleFromSelection"></ExampleCompanyMenu>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-form>
                    </CommonLabelContainer>
                </div>
            </div>
            <div class="row table-space p-3">

                <div class="container-fluid">
                    <div class="row">
                        <div class="col-10">
                            <b>Visar {{companies.length}} företag</b>
                            <div class="mt-3">
                                <v-text-field @change="loadCompanies" bg-color="white"
                                              name="FilterCompanyName"
                                              id="FilterCompanyName"
                                              type="text"
                                              label="Filtrera på företagsnamn, email eller avdelningsnamn"
                                              variant="outlined"
                                              v-model="filter"
                                              focused="true"></v-text-field>
                            </div>
                        </div>
                        <div class="col-2 text-right p-0">
                            <v-menu>
                                <template v-slot:activator="{ props }">
                                    <v-btn-toggle variant="outlined" density="compact">
                                        <v-btn icon="mdi-cog-outline" v-bind="props" style="margin-top:1px;" density="comfortable"></v-btn>
                                    </v-btn-toggle>
                                </template>
                                <v-list>
                                    <v-list-item :value="1" @click="showDisabledCompanies = 1" v-bind:append-icon="getIcon(1)">
                                        <v-list-item-title>
                                            Visa aktiva
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item :value="2" @click="showDisabledCompanies = 2" v-bind:append-icon="getIcon(2)">
                                        <v-list-item-title>Visa alla</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </div>
                </div>

                <table class="mt-2 table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                    <thead>
                        <tr>
                            <th class="col-2">Namn</th>
                            <th class="col-2">Status</th>

                            <th class="col-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in getCompanies()" :key="index">
                            <td>{{item.Name}}</td>
                            <td>{{item.Status}}</td>

                            <td valign="middle">
                                <div class="pull-right" style="">
                                    <div class="dropdown text-right pr-2">
                                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                            ...
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a href="javascript:void(0)" class="dropdown-item" @click="updateCompany(item)">Ändra</a>
                                            <a href="javascript:void(0)" class="dropdown-item" @click="copyCompany(item)">Kopiera</a>
                                            <a v-if="item.IntStatus == 10" href="javascript:void(0)" class="dropdown-item" @click="setCompanyDeleted(item.CompanyId)">Ta bort</a>
                                            <a v-if="item.IntStatus == 30" href="javascript:void(0)" class="dropdown-item" @click="reactivateCompany(item.CompanyId)">Återaktivera</a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <AdminUpdateCompany ref="updateCompanyModal" @updated="loadCompanies"></AdminUpdateCompany>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>
    import ValidationService from "../../Services/ValidationService";
    import AdminService from "../../Services/AdminService";
    import CommonLabelContainer from "../../common/common-label-container";
    import AdminUpdateCompany from './update/update-company.vue'
    import CommonSpinner from '../../common/common-spinner.vue'
    import ExampleCompanyMenu from './common/example-company-menu.vue'
    import moment from 'moment'
    import { ref } from 'vue'
    const form = ref(null);
    const updateCompanyModal = ref(null);


    export default {

        name: 'admin-company-workspace',
        props: {

        },
        components: {
            CommonLabelContainer,
            AdminUpdateCompany,
            CommonSpinner,
            ExampleCompanyMenu
        },
        methods: {

            async createExample(){
                this.loading++;
                try{
                    await AdminService.createWorkspaceCompanyFromExample(this.exampleCompany);
                    this.displaySnackBar("Exempelbolaget skapades");
                    this.loadCompanies();
                    window.refreshCompanies()
                }
                catch(error){
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async createExampleFromSelection(item) {
                this.loading++;
                try {
                    const companyToCreate = {
                        ...this.exampleCompany,
                        ExampleCompanyId: item.CompanyId
                    };
                    await AdminService.createWorkspaceCompanyFromExample(companyToCreate);
                    this.displaySnackBar("Exempelbolaget skapades");
                    this.loadCompanies();
                    window.refreshCompanies()
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async createCompany() {
                this.loading++;
                try{
                    await AdminService.createWorkspaceCompany(this.company);
                    this.displaySnackBar("Bolaget skapades");
                    this.loadCompanies();
                    window.refreshCompanies()
                }
                catch(error){
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async copyCompany(company) {
                this.loading++;
                var idToCopy = company.CompanyId;
                var nameOfCopy = company.Name + "_kopia";
                 try{
                     await AdminService.copyCompany(idToCopy, nameOfCopy);
                     this.displaySnackBar("Bolaget kopierades");
                     this.loadCompanies();
                     window.refreshCompanies()
                 }
                 catch(error){
                     this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async setCompanyDeleted(companyId) {
                if (confirm("Är du säker att du vill radera företaget?")) {
                    this.loading++;
                    try {
                        await AdminService.setCompanyDeleted(companyId);
                        this.displaySnackBar("Bolaget togs bort");
                        this.loadCompanies();
                        window.refreshCompanies()
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async reactivateCompany(companyId) {
                if (confirm("Är du säker att du vill återaktivera företaget?")) {
                    this.loading++;
                    try {
                        await AdminService.setCompanyActive(companyId);
                        this.displaySnackBar("Bolaget återaktiverades");
                        window.refreshCompanies()
                        this.loadCompanies();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            
            async loadCompanies() {
                this.loading++;
                try {
                    if (this.showDisabledCompanies == 2)
                        this.companies = await AdminService.getWorkSpaceCompaniesWithDeleted(this.filter);
                    else
                        this.companies = await AdminService.getWorkSpaceCompanies(this.filter);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadAvailableExampleCompanies() {
                this.loading++;
                try {
                    this.availableExampleCompanies = await AdminService.getAvailableExampleCompanies();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async updateCompany(company) {
                this.loading++;
                this.updateCompanyModal.open(company)
                this.loading--;
            },
            getIcon(option) {
                if (this.showDisabledCompanies == option)
                    return "mdi-check";
                return "";
            },
            getCompanies() {
                return this.companies;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                filter: null,
                rules: ValidationService.rules(),
                company: {
                    Name: ''
                },
                exampleCompany: {
                    Name: ''
                },
                availableExampleCompanies: [],
                companies: [],
                showDisabledCompanies: 1,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
                loading: 0,
            };
        },
        watch: {
            showDisabledCompanies: function () {
                this.loadCompanies();
            },
        },
        mounted() {
            this.loadCompanies();
            this.loadAvailableExampleCompanies();
            this.exampleCompany.Name = "Exempel " + (moment()).format("YYYY-MM-DD");
        },
        setup() {
            return { form, updateCompanyModal }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
